import React from 'react';
import { NoticeBar as OldNoticeBar } from 'antd-mobile';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.modules.less';

const Dom = (props) => {
  const { type, className, children, ...rest } = props;

  return (
    <OldNoticeBar
      {...rest}
      className={cx(
        {
          [styles.oldType]: type == 'old'
        },
        className
      )}>
      {children}
    </OldNoticeBar>
  );
};

const NoticeBar = (props) => {
  return <Dom {...props} />;
};

NoticeBar.defaultProps = {
  type: 'old',
  className: ''
};

NoticeBar.propsTypes = {
  type: PropTypes.oneOf(['old', 'regular']),
  className: PropTypes.string
};

export default NoticeBar;



// WEBPACK FOOTER //
// ./src/widget/NoticeBar/index.js